$ () ->
    $.widget 'custom.resizr',
        options:
            parent: null
            siblings: null
            widthSiblings: null
            use_max: null
            use_width: null
            fudge: 0
            new_size: null

        sizeCalc: null
        widthCalc: null

        _init: () ->
            return @resize()

        _create: () ->
            undefined

        _setOption: () ->
            undefined

        destroy: () ->
            undefined

        resize: () ->
            # This calculation is correct.  Meatspace verified.
            parent = (@options.parent ? @element.parent()).height()
            siblings = @options.siblings ? @element.siblings()
            sibheight = 0

            siblings.each () ->
                if $(this).prop('tagName') isnt 'STYLE' and $(this).css('position') isnt 'absolute'
                    sibheight += $(this).outerHeight(true)

            padding = @element.outerHeight(true) - @element.height()

            if @options.new_size?
                size = @options.new_size
            else
                size = parent - sibheight - padding
                size = size + @options.fudge

            @sizeCalc = size
            @widthCalc = @element.width()

            if @options.use_max
                @element.css({ 'max-height': size + 'px' })
            else
                @element.css({ height: size + 'px' })

            # Do the width too
            if @options.use_width
                parent =  (@options.parent ? @element.parent()).width()
                siblings = @options.widthSiblings
                sibwidth = 0
                siblings?.each () ->
                    sibwidth += $(this).outerWidth(true)

                padding = @element.outerWidth(true) - @element.width()

                size = parent - sibwidth - padding

                if size < @widthCalc
                    @widthCalc = size
                    if @options.use_max
                        # console.log "should be setting max-width = #{size}"
                        @element.css({ 'max-width': size + 'px' })
                    else
                        @element.css({ width: size + 'px' })

            return size

        size: () ->
            return @sizeCalc

        width: () ->
            return @widthCalc
